/* http://jsfiddle.net/wewu0os9/12/ */
(function (H) {
		
  H.wrap(H.seriesTypes.column.prototype, "drawGraph", function () {
    /* For SNS column-charts The xAxis should be 100%-width; 
       However the legend is placed aside of the chart (and not inside)
       Therefore the default xAxis is too short; below we draw the xAxis until the end of the image (so it continues beneath the legend)
    */

    var chart = this.chart,
        r = chart.renderer,
        xAxis = H.charts[0].xAxis[0];
        
    var chartLength = chart.chartWidth - chart.spacing[1] - chart.spacing[3], /* SNS uses 10px spacing left/right which is not considered to be within the chart-area */
        xAxisPositionY = xAxis.top + xAxis.height,
        xAxisPositionX = xAxis.left
        ;
    
    try {
      /* Draw rectangle in the correct shape (line of width 0.35) at the xAxis */
      r.rect(xAxisPositionX, xAxisPositionY, chart.chartWidth - xAxisPositionX - chart.spacing[1], 0.35, 0)
        .attr({
          fill: xAxis.axisLine.stroke,
          zIndex: 3
        }).add();
    } catch(err) {
      console.log('callback; For SNS column-charts The xAxis should be 100%-width: ' + err);
    }
             
  });
  
  H.wrap(H.seriesTypes.pie.prototype, "drawDataLabels", function (p) {
    /* SNS-PIE-LABELING */
    /* Use straight connector lines to connect a pie-part and the corresponding label */
       
    var chart = this.chart,
            r = chart.renderer,
            t = this;
    var x_left_correction = 2,
        x_right_correction = -4; /* for some reason labels are not always rendered/aligned correctly; Therefore these variable are used to shift label into the correct position. Note that you must develop on production to see the true effect of these values in the PDF! */
    var conn_outdent = 0; /* For labels at the top or bottom of the pie the connector outdents; For others labels it does not. Initialy this variable should be 0 */
    
    p.call(this);
    
    console.log('Log H:');
    console.log(H);
    console.log('Log p:');
    console.log(p);
    console.log('Log t:');
    console.log(t);
    
    var tngLabelFormat;
    
    try {
      tngLabelFormat = chart.options.plotOptions.pie.tngLabels; 
    } catch (err) {
      tngLabelFormat = 'false';
    };
    if (tngLabelFormat && tngLabelFormat!='false'){
      if (tngLabelFormat.enabled='true') { 
        
        /* For each point/datalabel do */
        H.each(this.points, function (p) {
          var labelSide = (p.labelPos[6] === "right" ? "left" : "right");
          
          if (p.dataLabel && p.connector) {
            try {
              /* ??? p.labelPos is an array containing the x,y positions of the label-side connector-point (0,1), pie-side connector point (4,5) and the text-label (2?,3?). The sixth array-entry contains 'right' or 'left'  which indicates the alignment of the label with respect to its point. */  
              if (p.labelPos[6] === "right") {
                /* Set the alignment of the data label compared to the point to the left: */
                p.dataLabel.alignSetter("left");
              } else {
                /* Set the alignment of the data label compared to the point to the right: */
                p.dataLabel.alignSetter("right"); 
              }
              
              /* Reset the label-position (keep same height (= y)) */       
              p.dataLabel.attr({
                /* The positioning of datalabels is relative to the charArea (without the spacing araound the chart); therefore x = 0 is positioned at chart.spacing[3] distance from the SVG-image */
                x: (labelSide === "right" ? chart.chartWidth - chart.spacing[1] - chart.spacing[3] + x_right_correction : 0 + x_left_correction),
                y: p.labelPos[5]
              });
              
              /* draw the connector; "M": MoveTo; "L": LineTo; see also: http://www.w3schools.com/svg/svg_path.asp */
              p.connector.attr({
                d: [
                    "M",
                p.labelPos[4],
                p.labelPos[5],
                    "L", 
               (p.labelPos[6] === "right" ? 0 : t.center[0] * 2),
                p.labelPos[5]]
              });
              
              /* for connecter lines starting at the top or bottom of the pie (x-position is close to the center of the pie): outdent the connector */
              if (Math.abs(t.center[0] - p.labelPos[4]) < 20) { 
                conn_outdent = 12;
                if (t.center[1] - p.labelPos[5] > 0) {
                  /* use negative outdent at the bottom */
                  conn_outdent = -1 * conn_outdent;
                };
                
                /* (re)draw the connector line; "M": MoveTo; "L": LineTo; see also: http://www.w3schools.com/svg/svg_path.asp */
                p.connector.attr({
                  d: [
                    "M",
                  p.labelPos[4],
                  p.labelPos[5],
                    "L", 
                  p.labelPos[4],
                  p.labelPos[5] + conn_outdent,
                    "L", 
                 (p.labelPos[6] === "right" ? 0 : t.center[0] * 2),
                  p.labelPos[5] + conn_outdent]
                });
                
                /* set-y position of datalabel */
                p.dataLabel.attr({
                  y: p.labelPos[5] + conn_outdent
                })
              };
            } catch (err) {
              console.log('callback; drawDataLabels; reposition labels and connectors: ' + err);
            }
            
            /* draw %-block */
            try {
              
              var labelHeight = 18.9 - 4; /* 18.9px = 5mm; - padding top/bottom */
              /* p.options.y or p.percentage*/
              r.label(Highcharts.numberFormat(p.percentage, 1) + '%', (p.labelPos[6] === "right" ? chart.spacing[1] - 2 : chart.chartWidth - chart.spacing[3] + 2), p.labelPos[5] + conn_outdent + 1 - (labelHeight + 4) / 2).css({
                  color: tngLabelFormat.style.color,
                  fontFamily: tngLabelFormat.style.fontFamily,
                  fontSize: tngLabelFormat.style.fontSize,
                  fontWeight: tngLabelFormat.style.fontWeight,
                  padding: 0,
                })
                .attr({
                  fill: tngLabelFormat.backgroundColor,
                  /* todo pantone/cmyk color? */
                  padding: 2,
                  zIndex: 6,
                  height: labelHeight,
                  align: (p.labelPos[6] === "right" ? 'left' : 'right'),
                  verticalAlign: 'bottom'
                }).add();
            } catch (err) {
              console.log('callback; drawDataLabels; draw %-block: ' + err);
            }
          }
        });
      } 
    }
  });
  
})(Highcharts)

cb = function (chart) {
  
  // equally spread legend items in the available space
  var legend = chart.legend, each = Highcharts.each, x, y;
  
  if (legend.allItems) {
    each(legend.allItems, function(item, i){
      var itemMarginLeft = item.hasOwnProperty('userOptions') ? item.userOptions.itemMarginLeft : item.itemMarginLeft;
      
      if (itemMarginLeft){
        x = item.legendGroup.translateX + itemMarginLeft;
        y = item.legendGroup.translateY;
        item.legendGroup.translate(x,y);
      }
    });
  }
  
  // place datalabels centered outside slice
  
  if (chart.options.chart.type=='pie') {
    try {
      var tngLabelFormat = chart.options.plotOptions.pie.tngLabels;  
      if (tngLabelFormat.enabled='false') {
        $.each(chart.series,function(){
          $.each(this.data, function(index, point) {
            if (point.dataLabel) {
              var distance = 11;
              var xDelta   = (distance + point.dataLabel.width / 5) * Math.cos(point.angle);
              var yDelta   = distance * 0.8 * Math.sin(point.angle);
              point.dataLabel.translateX += xDelta;
              point.dataLabel.translateY += yDelta;
              point.dataLabel.updateTransform();
            }
          });
        });
      }
    } catch (err) {
      console.log('callback; place datalabels centered outside slice: ' + err);
    }
  }
}


/*	old function changed the color of the label; based on its position
  function formatDatalabelsColumn(dl,yLabelSuffix,decimalAmount) {
      var max    = dl.series.yAxis.max, 
			ypos   = dl.series.yAxis.toPixels(dl.y),
			maxpos = dl.series.yAxis.toPixels(max),
			color = ypos - maxpos > 13.5 ? '#16469C' : '#FFFFFF'
		return '<span style="color:' + color + '">' + Highcharts.numberFormat(dl.y,decimalAmount) + yLabelSuffix + '</span>';
	};
*/
function formatStackTotalColumn(dl, yLabelSuffix, decimalAmount) {
		try {
      var categoryIndex = dl.x;
      var tngCategory = dl.axis.chart.options.xAxis[0].tngCategories[categoryIndex];

      if (tngCategory.color) {
        return '<span style="color:' + tngCategory.color + '; font-weight:bold">' + Highcharts.numberFormat(dl.total, decimalAmount) + yLabelSuffix + '</span>';
      } else {
        return dl.total + yLabelSuffix;
      }
    } catch (err) {
      console.log('callback; formatStackTotalColumn: ' + err);
    	return dl.total + yLabelSuffix;
    }
  }
  
  function formatDatalabelsColumn(dl,yLabelSuffix,decimalAmount) {
		if (dl.y == 0) {
      return '';
    } else {
      return Highcharts.numberFormat(dl.y,decimalAmount) + yLabelSuffix;
    }
	};
  
  function formatDatalabelsPie(dl,labelSuffix,decimalAmount) {
		if (dl.y == 0) {
      return '';
    } else {
      return Highcharts.numberFormat(dl.y,decimalAmount) + labelSuffix;
    }
	};
  function formatxAxisLabels(dl, xLabelSuffix, decimalAmount) {
  	try {
    	var categoryIndex = dl.axis.categories.indexOf(dl.value);
   		var tngCategory = dl.chart.options.xAxis[0].tngCategories[categoryIndex];
    
      if (tngCategory.color) { 
        return '<span style="color:' + tngCategory.color + '; font-weight:bold">' + dl.value + xLabelSuffix + '</span>';
      } else {
        return dl.value + xLabelSuffix;
      }
    } catch(err){
      console.log('callback; formatxAxisLabels: ' + err);
    	return dl.value + xLabelSuffix;
    }
  };